/**
 * Slotti-ajanvaraus modaalina (snippets/slotti-modal.liquid).
 *
 * Avaajat: linkit, joiden osoite päättyy #varaa-sovitus, ja elementit, joilla on data-slotti.
 * Iframe ladataan vasta ensimmäisellä avauksella. Natiivi <dialog> hoitaa Escin ja fokuksen
 * lukituksen; sulkemisen jälkeen fokus palautetaan avanneeseen elementtiin.
 */
(function () {
  const HASH = '#varaa-sovitus';
  const PARAMS = ['liike', 'palvelu', 'tuote'];

  const dialog = document.getElementById('slotti-modal');
  if (!dialog || typeof dialog.showModal !== 'function') {
    // Ei modaalia: linkit toimivat tavallisina linkkeinä (layout/theme.liquid:n varhainen kuuntelija ohitetaan)
    window.hxSlottiReady = true;
    return;
  }

  const frame = dialog.querySelector('[data-slotti-frame]');
  let opener = null;

  /** @param {Element} trigger */
  function buildSrc(trigger) {
    const base = dialog.dataset.src;
    if (!base) return '';

    let url;
    try {
      url = new URL(base, window.location.href);
    } catch (error) {
      return base;
    }

    let linkParams = null;
    if (trigger instanceof HTMLAnchorElement && trigger.href) {
      try {
        linkParams = new URL(trigger.href, window.location.href).searchParams;
      } catch (error) {
        linkParams = null;
      }
    }

    for (const key of PARAMS) {
      const paramName = dialog.getAttribute(`data-param-${key}`);
      if (!paramName) continue;
      const value = trigger.getAttribute(`data-${key}`) || (linkParams && linkParams.get(key));
      if (value) url.searchParams.set(paramName, value);
    }

    return url.toString();
  }

  // Slottin upotus tarvitsee noin 390 px leveyttä. Kapeammilla puhelimilla (esim. iPhone SE, 375 px)
  // iframe piirretään 390 px:n levyisenä ja skaalataan mahtumaan, jottei siihen tule vaakavieritystä.
  const FRAME_MIN_WIDTH = 390;

  function fitFrame() {
    if (!frame || !dialog.open) return;
    const box = frame.parentElement;
    if (!box) return;

    frame.removeAttribute('data-scaled');
    frame.style.removeProperty('width');
    frame.style.removeProperty('height');
    frame.style.removeProperty('transform');

    const width = box.clientWidth;
    if (!width || width >= FRAME_MIN_WIDTH) return;

    const scale = width / FRAME_MIN_WIDTH;
    frame.setAttribute('data-scaled', '');
    frame.style.width = `${FRAME_MIN_WIDTH}px`;
    frame.style.height = `${box.clientHeight / scale}px`;
    frame.style.transform = `scale(${scale})`;
  }

  /** @param {Element} trigger */
  function open(trigger) {
    opener = trigger;

    if (frame) {
      const src = buildSrc(trigger);
      if (src && frame.getAttribute('src') !== src) frame.setAttribute('src', src);
    }

    if (!dialog.open) dialog.showModal();
    window.requestAnimationFrame(fitFrame);
  }

  window.addEventListener('resize', () => window.requestAnimationFrame(fitFrame));

  function close() {
    if (dialog.open) dialog.close();
  }

  /** @param {EventTarget | null} target */
  function findTrigger(target) {
    // Klikkaus voi osua tekstisolmuun (osa selaimista): käytetään sen vanhempaa elementtiä
    if (target instanceof Node && !(target instanceof Element)) target = target.parentElement;
    if (!(target instanceof Element)) return null;

    const dataTrigger = target.closest('[data-slotti]');
    if (dataTrigger) return dataTrigger;

    const link = target.closest('a[href]');
    if (link && link.getAttribute('href').endsWith(HASH)) return link;

    return null;
  }

  // Kaappausvaiheessa, jotta mikään muu kuuntelija ei ehdi pysäyttää tapahtumaa ja linkki ei etene etusivulle
  document.addEventListener(
    'click',
    (event) => {
      const trigger = findTrigger(event.target);
      if (!trigger || dialog.contains(trigger)) return;

      event.preventDefault();
      open(trigger);
    },
    true
  );

  // Varalla: jos osoitteeseen tulee #varaa-sovitus (esim. linkki samalle sivulle), avataan modaali
  window.addEventListener('hashchange', () => {
    if (window.location.hash === HASH) open(document.body);
  });

  dialog.addEventListener('click', (event) => {
    // Taustaklikkaus: klikkaus osuu itse dialogiin eikä sen sisältöön
    if (event.target === dialog || (event.target instanceof Element && event.target.closest('[data-slotti-close]'))) {
      close();
    }
  });

  dialog.addEventListener('close', () => {
    if (opener instanceof HTMLElement && opener.isConnected) opener.focus();
    opener = null;
    // #varaa-sovitus pois osoitteesta, ettei sivun päivitys avaa modaalia uudelleen
    if (window.location.hash === HASH) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  });

  // Varhainen kuuntelija (layout/theme.liquid) ohittaa tästä eteenpäin; ennen valmistumista klikattu painike avataan nyt
  window.hxSlottiReady = true;
  const pending = window.hxSlottiPending;
  window.hxSlottiPending = null;

  if (pending instanceof Element && pending.isConnected) {
    open(pending);
  } else if (window.location.hash === HASH) {
    // Suora linkki sivulle, esim. hiusextra.fi/#varaa-sovitus
    open(document.body);
  }
})();
